import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {removeNonDigits} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

const defaultState = {
    listType: 0,
    fromSection: '',
    toSection: '',
    championshipNo: '',
    rank: '',
    week: '',
    colourCode: '',
    signature: false,
    sortByGender: false,
    sortBySection: false,
    areaWinners: false,
}

class SeasonDiplomas extends React.Component {
    constructor(props) {
        super(props);
        this.state = defaultState
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //if(this.state.listType !== prevState.listType) {
        //    this.setState(Object.assign(defaultState, {listType: this.state.listType}))
        //}
    }
    fields = [];

    render() {
        return <div className="season-diplomas">
            <div className={'upper-container'}>
                <div className={'radio-buttons-container column-gap'}>
                    <div className="radio-button-container">
                        <input id="championships" type="radio" checked={this.state.listType === 0} onChange={() => this.setState({listType: 0})}/>
                        <label htmlFor="championships">Mesterskaber</label>
                    </div>
                    <div className="radio-button-container">
                        <input id="pigeon-championships" type="radio" checked={this.state.listType === 1} onChange={() => this.setState({listType: 1})}/>
                        <label htmlFor="pigeon-championships">ES-due</label>
                    </div>
                    <div className="radio-button-container">
                        <input id="race-winners" type="radio" checked={this.state.listType === 2} onChange={() => this.setState({listType: 2})}/>
                        <label htmlFor="race-winners">{this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? 'Sektionsvindere' : this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? 'Foreningsvindere' : 'Område/sektionsvindere'}</label>
                    </div>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div className="radio-button-container">
                        <input id="region-winners" type="radio" checked={this.state.listType === 3} onChange={() => this.setState({listType: 3})}/>
                        <label htmlFor="region-winners">Regionsvindere</label>
                    </div> : null}
                </div>
                <div className={'input-fields'}>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div className={'attribute-row'}>
                        <div className={'attribute-pair left-pair'}>
                            <label>Fra sektion</label>
                            <UserFieldElement
                                dataType={UserFieldDataType.regex}
                                placeholder=""
                                className="field-1 very-small-field"
                                containerClassName="display-inline-block"
                                name="fromSection"
                                id="fromSection"
                                maxLength="2"
                                options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                                value={this.state.fromSection}
                                autoCheckErrors={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onDigitInputFieldChange}
                                ref={instance => { this.fields[0] = instance; }}
                            />
                        </div>
                        <div className={'attribute-pair right-pair'}>
                            <label>Til sektion</label>
                            <UserFieldElement
                                dataType={UserFieldDataType.regex}
                                placeholder=""
                                className="field-1 very-small-field"
                                containerClassName="display-inline-block"
                                name="toSection"
                                id="toSection"
                                maxLength="2"
                                options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                                value={this.state.toSection}
                                autoCheckErrors={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onDigitInputFieldChange}
                                ref={instance => { this.fields[1] = instance; }}
                            />
                        </div>
                    </div> : null}
                    <div className={'attribute-row'}>
                        <div className={'attribute-pair left-pair'}>
                            <label>{this.state.listType > 1 ? 'Uge' : 'Mesterskabskode'}</label>
                            <UserFieldElement
                                dataType={UserFieldDataType.regex}
                                placeholder=""
                                className="field-1 very-small-field"
                                containerClassName="display-inline-block"
                                name={this.state.listType > 1 ? 'week' : 'championshipNo'}
                                id={this.state.listType > 1 ? 'week' : 'championshipNo'}
                                maxLength={this.state.listType > 1 ? 2 : 3}
                                required={this.state.listType > 1 ? false: true}
                                options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: `[0-9]{${this.state.listType > 1 ? '0,2' : 3}}`}]}
                                value={this.state.listType > 1 ? this.state.week : this.state.championshipNo}
                                autoCheckErrors={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onDigitInputFieldChange}
                                onBlur={() => {
                                    this.fields[2].setState({focused: false, visited: true});
                                    if(this.state.listType <= 1){
                                        if (/^[0-9]{1,2}$/.test(this.state.championshipNo)) this.setState({championshipNo: this.state.championshipNo.padStart(3, '0')});
                                    }
                                }}
                                ref={instance => { this.fields[2] = instance; }}
                            />
                        </div>
                        <div className={'attribute-pair right-pair'}>
                            <label>{this.state.listType > 1 ? 'Farvekode' : 'Placering'}</label>
                            <UserFieldElement
                                dataType={UserFieldDataType.regex}
                                placeholder=""
                                className="field-1 very-small-field"
                                containerClassName="display-inline-block"
                                name={this.state.listType > 1 ? 'colourCode' : 'rank'}
                                id={this.state.listType > 1 ? 'colourCode' : 'rank'}
                                maxLength={this.state.listType > 1 ? 2 : 3}
                                options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: `[0-9]{${this.state.listType > 1 ? 2 : '1,3'}}`}]}
                                value={this.state.listType > 1 ? this.state.colourCode : this.state.rank}
                                autoCheckErrors={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onDigitInputFieldChange}
                                onBlur={() => {
                                    this.fields[3].setState({focused: false, visited: true});
                                }}
                                ref={instance => { this.fields[3] = instance; }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="lower-container options-group">
                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div>
                    <input id="signature" name="signature" type="checkbox" checked={this.state.signature} onClick={e => this.setState({signature: !this.state.signature})}/>
                    <label htmlFor="signature">Vis signatur</label>
                </div> : null}
                {this.state.listType === 1 ?
                    [<div>
                        <input id="sortByGender" name="sortByGender" type="checkbox" checked={this.state.sortByGender}
                               onClick={e => this.setState({sortByGender: !this.state.sortByGender})}/>
                        <label htmlFor="sortByGender">Udskriv kønsvist</label>
                    </div>,
                    this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div>
                        <input id="sortBySection" name="sortBySection" type="checkbox" checked={this.state.sortBySection}
                               onClick={e => this.setState({sortBySection: !this.state.sortBySection})}/>
                        <label htmlFor="sortBySection">Udskriv sektionsvist</label>
                    </div> : null]
                    : null
                }
                {this.state.listType === 2  && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                    <div>
                        <input id="areaWinners" name="areaWinners" type="checkbox" checked={this.state.areaWinners}
                               onClick={e => this.setState({areaWinners: !this.state.areaWinners})}/>
                        <label htmlFor="areaWinners">Vis områdevindere</label>
                    </div>
                    : null
                }
            </div>
        </div>
    }

    onDigitInputFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: removeNonDigits(e.target.value)});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        if (this.state.fromSection !== '' && this.state.toSection !== '' && this.state.fromSection > this.state.toSection) errors.push(`Fra sektion kan ikke være større end Til sektion.`);

        const options = {
            listType:       this.state.listType,
            fromSection:    this.state.fromSection === '' ? null : this.state.fromSection,
            toSection:      this.state.toSection   === '' ? null : this.state.toSection,
            championshipNo: this.state.listType > 1 ? null : this.state.championshipNo,
            rank:          (this.state.listType > 1 || this.state.rank === '') ? null : this.state.rank,
            signature:      this.state.signature,
            week:          (this.state.listType <= 1 || this.state.week === '') ? null : this.state.week,
            colourCode:    (this.state.listType <= 1 || this.state.colourCode === '') ? null : this.state.colourCode,
            sortByGender:   this.state.listType === 1 ? this.state.sortByGender : null,
            sortBySection:  this.state.listType === 1 ? this.state.sortBySection : null,
            areaWinners:    this.state.listType === 2 ? this.state.areaWinners : null,
        }
        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(SeasonDiplomas);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/SeasonDiplomas.js